var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.5C18.75 16.4946 18.3549 17.4484 17.6517 18.1517C16.9484 18.8549 15.9946 19.25 15 19.25C14.0054 19.25 13.0516 18.8549 12.3483 18.1517C11.6451 17.4484 11.25 16.4946 11.25 15.5C11.25 14.5054 11.6451 13.5516 12.3483 12.8483C13.0516 12.1451 14.0054 11.75 15 11.75C15.9946 11.75 16.9484 12.1451 17.6517 12.8483C18.3549 13.5516 18.75 14.5054 18.75 15.5Z",
    stroke: "#50AF47",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5C4.5 10.3787 9.17 6.75 15 6.75C20.83 6.75 25.5 10.3787 27.5 15.5C25.5 20.6213 20.83 24.25 15 24.25C9.17 24.25 4.5 20.6213 2.5 15.5Z",
    stroke: "#50AF47",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/iconView.9684df7f6baed423c5839800c5d34d20.svg";
export { ForwardRef as ReactComponent };